import { useState } from "react";
import { Container } from "../../components/styled/styled-components";
import { useDocumentTitle } from "../../hooks/document-title";
import AddressBookContainer from "./AddressBook/AddressBookContainer";
import ChangePassword from "./ChangePassword/ChangePassword";
import CustomerInfo from "./CustomerInfo/CustomerInfo";
import cx from "classnames";
import Clipboard from "../../assets/clipboard";
import Pencil from "../../assets/pencil";
import AddressBook from "../../assets/addressBook";

const Preferences = () => {
  useDocumentTitle("Preferences");
  const [currentTabIndex, setCurrentTabIndex] = useState(0);

  const tabs = [
    {
      label: "Your Information",
      icon: <Clipboard width={20} height={20} />,
      component: <CustomerInfo />,
    },
    {
      label: "Change Password",
      icon: <Pencil width={20} height={20} />,
      component: <ChangePassword />,
    },
    {
      label: "Address Book",
      icon: <AddressBook width={20} height={20} />,
      component: <AddressBookContainer />,
    },
  ];

  return (
    <Container className="preferences">
      <div className="preferences-wrapper">
        <aside className="preferences-sidebar">
          <nav className="preferences-nav" role="tablist">
            {tabs.map((tab, index) => (
              <button
                key={index}
                type="button"
                className={cx("preferences-nav-item", index === currentTabIndex && "active")}
                onClick={() => setCurrentTabIndex(index)}
                aria-selected={index === currentTabIndex}
                role="tab"
                aria-controls={`tabpanel-${index}`}
                id={`tab-${index}`}
              >
                <span className="nav-item-icon">{tab.icon}</span>
                <span className="nav-item-label">{tab.label}</span>
              </button>
            ))}
          </nav>
        </aside>

        <div className="preferences-content">
          <div
            className="preferences-panel"
            id={`tabpanel-${currentTabIndex}`}
            role="tabpanel"
            aria-labelledby={`tab-${currentTabIndex}`}
            key={currentTabIndex}
          >
            {tabs[currentTabIndex].component}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Preferences;
